<iframe
  src="https://app.theneo.io/appworldsa/api"
  style="display: block; width: 100%; height: 100vh"
  seamless="seamless"
  frameborder="0"
  scrolling="yes"
></iframe>
